const rub = new Intl.NumberFormat('ru-RU');

/** "5 000 ₽" */
export function money(value: number): string {
  return `${rub.format(Math.round(value))} ₽`;
}

/** "300 000" (no currency, for big guarantees) */
export function compact(value: number): string {
  return rub.format(Math.round(value));
}

const dateFmt = new Intl.DateTimeFormat('ru-RU', { day: 'numeric', month: 'long' });
const shortDateFmt = new Intl.DateTimeFormat('ru-RU', { day: '2-digit', month: '2-digit' });
const timeFmt = new Intl.DateTimeFormat('ru-RU', { hour: '2-digit', minute: '2-digit' });
const weekdayFmt = new Intl.DateTimeFormat('ru-RU', { weekday: 'long' });
const monthShortFmt = new Intl.DateTimeFormat('ru-RU', { month: 'short' });
const dayKeyFmt = new Intl.DateTimeFormat('ru-RU', { day: 'numeric', month: 'long', weekday: 'short' });

export function dateLabel(iso: string): string {
  return dateFmt.format(new Date(iso));
}
/** "26.10" — compact numeric day.month */
export function shortDate(iso: string): string {
  return shortDateFmt.format(new Date(iso));
}
/** "26" — day of month for the schedule date-block */
export function dayNum(iso: string): string {
  return String(new Date(iso).getDate());
}
/** "ОКТ" — uppercase 3-letter month for the schedule date-block */
export function monthAbbr(iso: string): string {
  return monthShortFmt.format(new Date(iso)).replace('.', '').toUpperCase();
}
export function timeLabel(iso: string): string {
  return timeFmt.format(new Date(iso));
}
export function weekday(iso: string): string {
  const w = weekdayFmt.format(new Date(iso));
  return w.charAt(0).toUpperCase() + w.slice(1);
}
export function dateGroupKey(iso: string): string {
  return dayKeyFmt.format(new Date(iso));
}

/** "1-е место" / "—" */
export function placeLabel(position: number | null): string {
  if (position === null) return '—';
  return `${position}-е место`;
}

export function nbsp(s: string): string {
  return s.replace(/ /g, ' ');
}

/* ── Seasons & chapters ─────────────────────────────────────
   Every 10 seasons open a new chapter: absolute season 11 is
   «Первый сезон» of chapter 2. Names are ordinal words. */
const SEASON_ORDINALS = [
  'Первый', 'Второй', 'Третий', 'Четвёртый', 'Пятый',
  'Шестой', 'Седьмой', 'Восьмой', 'Девятый', 'Десятый',
];

export function seasonChapter(id: number): number {
  return Math.floor((id - 1) / 10) + 1;
}

export function seasonName(id: number): string {
  return `${SEASON_ORDINALS[(id - 1) % 10]} сезон`;
}

/** Name with chapter context when beyond chapter 1: «Первый сезон · глава 2». */
export function seasonLabel(id: number): string {
  const ch = seasonChapter(id);
  return ch > 1 ? `${seasonName(id)} · глава ${ch}` : seasonName(id);
}

/** Русские формы: plural(3, ['сезон','сезона','сезонов']) → «сезона». */
export function plural(n: number, forms: [string, string, string]): string {
  const abs = Math.abs(n) % 100;
  const d = abs % 10;
  if (abs > 10 && abs < 20) return forms[2];
  if (d === 1) return forms[0];
  if (d >= 2 && d <= 4) return forms[1];
  return forms[2];
}
